import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { viewIncrementApi } from '../../API/API'

function* viewIncrementSaga(params) {
    try {
        const response = yield call(() => viewIncrementApi(params)); 
        yield put({type: types.VIEW_INCREMENT_SUCCESS, payload: response.data});
      }
      catch (error) {
        yield put({type: types.VIEW_INCREMENT_FAILURE, error});
    }
}

export function* watchviewIncrementSagaSaga() {
    yield takeEvery(types.VIEW_INCREMENT_REQUESTED, viewIncrementSaga);
}